// extracted by mini-css-extract-plugin
export default {"header":"Header_header__NwdvF","devider":"Header_devider__1mZEk","closeButton":"Header_closeButton__2Rja0","closeIcon":"Header_closeIcon__Phdo1"};